<template>
  <public-layout>
    <section class="hero lvl2">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="product-title">
                Fun Learning Classroom
              </p>
              <p class="product-subtitle">
                A safe and inspiring environment for Fun Learning!
              </p>
              <p class="product-description">
                Facilitates the creation of a Fun Learning Classroom through concept guidelines, designs and assistance with implementation.
                 Pedagogically designed to support diverse learning strategies.
                  Embodies a positive and respectful atmosphere, where children can organically strengthen their physical, social and emotional skills.
                   Learning environments are a key element in providing an effective kindergarten experience.
              </p>
              <p class="product-cta">
                <router-link class="button button-large button-secondary" :to="{ name: 'kinder' }">Go Back</router-link>
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/classroom-big.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <hr>

    <section class="section course-info is-left-aligned">
      <div class="container">
        <div class="columns">
          <div class="column is-4 is-offset-1">
            <figure class="image is-square">
              <img src="/static/img/assets/funacademy-classroom.jpg" alt="">
            </figure>
          </div>
          <div class="column is-5 is-offset-1">
            <h2 class="section-title">Transform your learning environment!</h2>
            <p class="content">
                The Fun Learning Classroom is a multifunctional space.
                <ul>
                  <li>Provides multiple spatial solutions for a variety of play and learning situations – as individuals and as groups.</li>
                  <li>Divided into sections, designed to promote discussion, collaboration and innovative thinking.</li>
                  <li>Encourages children to actively explore and participate in the learning environment.</li>
                  <li>Creates the opportunity to take acceptable risks in a stimulating, challenging and controlled environment to improve cognitive and fine motor skills, and sensory experiences.</li>
                </ul>
            </p>
          </div>
        </div>
      </div>
    </section>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import SectionContact from '@/components/SectionContact'
import Button from '@/components/Button'

export default {
  name: 'classroom',

  components: {
    PublicLayout,
    SectionContact,
    Button
  },

  created () {},

  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.subsection-subtitle{
    color: #6B7285;
    font-size: 1rem;
    margin-top: 1.6rem;
}

.section-testimonies{
  p{
    color: #6B7285;
    font-style: italic;
    font-size: 1.625rem;
    line-height: 1.55;
  }
  small{
    display: block;
    font-size: 1rem;
    padding-top: 1rem;
  }
}

.section-cta{
  .hero-body{
    padding-bottom: 0;
  }

  .image-wrapper{
    overflow:hidden;
    height: 400px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/ClassroomPage.vue